var App = App || {};

App.ProductPromos = (function ($) {
    "use strict";

    function init() {
        var $carouselSection = $("section.product-promos.carousel");

        if ($carouselSection.length) {
            $.each($carouselSection, function () {
                var $this = $(this),
                    $carousel = $this.find(".slides"),
                    $carouselControls = $this.find(".controls");

                if ($carousel.length) {
                    $carousel.slick({
                        appendArrows: $carouselControls,
                        arrows: true,
                        centerPadding: "1rem",
                        centerMode: true,
                        autoplay: false,
                        mobileFirst: true,
                        nextArrow: "<button class=\"slick-next slick-arrow\" aria-label=\"Next promotion\" type=\"button\"><span class=\"fas fa-fw fa-angle-right\"></span></button>",
                        prevArrow: "<button class=\"slick-prev slick-arrow\" aria-label=\"Previous promotion\" type=\"button\"><span class=\"fas fa-fw fa-angle-left\"></span></button>",
                        responsive: [
                            {
                                breakpoint: 575,
                                settings: {
                                    centerMode: false,
                                    slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    centerMode: false,
                                    slidesToShow: 3
                                }
                            }
                        ],
                        slidesToScroll: 1,
                        slidesToShow: 1
                    });
                }
            });
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.ProductPromos.init();
});